import { MemberTable } from '@services/member/member/member.types';
import { PaginationMetadata } from '@services/providers/cosem.types';
import { createColumnHelper } from '@tanstack/react-table';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useListPageVM = () => {
    const [totalCustomers, setTotalCustomers] = useState<number>(0);
    const columnHelper = createColumnHelper<MemberTable>();
    
    const navigate = useNavigate();

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalCustomers(metadata.total);
        }
    };

    return {
        handleMetadata,
        navigate,
        columnHelper,
        totalCustomers,
    };
};
